import React from 'react';
import classnames from 'classnames';
import classes from './SubCategoryNameDisplay.module.scss';

interface SubCategoryNameDisplayProps {
  subCategoryName: string;
}

export const SubCategoryNameDisplay = ({ subCategoryName }: SubCategoryNameDisplayProps) => {
  return <p className={classnames(classes.flex1, 'tbody-6 text-bold co-text-darker')}>{subCategoryName}</p>;
};
